
import {Component, Prop, Vue} from "vue-property-decorator";
import moment from "moment";

enum SeasonName {
  Summer = 'summer',
  Winter = 'winter',
  Autumn = 'autumn',
  Spring = 'spring',
}

enum DayMode {
  Day = 'day',
  Night = 'night',
}

@Component({})
export default class HomeLogo extends Vue {
  publicPath = process.env.VUE_APP_PUBLIC_URL;

  dayMode: DayMode = DayMode.Day;
  season: SeasonName  = SeasonName.Summer;

  mounted() {
    let hour = moment().format('HH');
    if (+hour >= 18 || +hour <= 6) {
      this.dayMode = DayMode.Night;
    }
    else {
      this.dayMode = DayMode.Day;
    }
    this.calculateSeason();
  }

  calculateSeason() {
    let month = moment().format('MM');
    let seasons = [
      { name: SeasonName.Summer, values: [6,7,8], },
      { name: SeasonName.Autumn, values: [9,10,11], },
      { name: SeasonName.Winter, values: [12,1,2], },
      { name: SeasonName.Spring, values: [3,4,5], },
    ];
    let imgSeason = seasons.find(item => item.values.includes(+month));
    if (imgSeason) this.season = imgSeason.name;
  }

  changeDayMode() {
    // if (this.dayMode === DayMode.Day) this.dayMode = DayMode.Night;
    // else this.dayMode = DayMode.Day;

    let images = [
      { season: SeasonName.Summer, dayMode: DayMode.Day },
      { season: SeasonName.Summer, dayMode: DayMode.Night },
      { season: SeasonName.Autumn, dayMode: DayMode.Day },
      { season: SeasonName.Autumn, dayMode: DayMode.Night },
      { season: SeasonName.Winter, dayMode: DayMode.Day },
      { season: SeasonName.Winter, dayMode: DayMode.Night },
      { season: SeasonName.Spring, dayMode: DayMode.Day },
      { season: SeasonName.Spring, dayMode: DayMode.Night },
    ];
    let currentImageIndex = images.findIndex(item => item.season === this.season && item.dayMode === this.dayMode);
    if (currentImageIndex !== -1) {
      let index = currentImageIndex + 1;
      if (index === images.length) index = 0;
      this.season = images[index].season;
      this.dayMode = images[index].dayMode;
    }
  }
}
